import { useState } from "react";
import { Link, NavLink, useLocation } from "react-router-dom";
import { AnimatePresence, motion } from "framer-motion";
import { Menu, X } from "lucide-react";
import { NAV_LINKS } from "@/lib/content";

export const SiteHeader = () => {
  const [open, setOpen] = useState(false);
  const location = useLocation();

  return (
    <header className="sticky top-0 z-50 border-b border-[#E2DACD]/60 bg-[#FAF7F2]/85 backdrop-blur-md">
      <div className="mx-auto flex max-w-6xl items-center justify-between px-5 py-4 sm:px-8">
        <Link to="/" data-testid="nav-logo" className="flex items-center" onClick={() => setOpen(false)}>
          <img src="/images/logo-horizontal.png" alt="Brian Boland Psychotherapy — Talk. Heal. Grow." className="h-11 w-auto sm:h-12" />
        </Link>

        <nav className="hidden items-center gap-7 lg:flex" aria-label="Main navigation">
          {NAV_LINKS.map((l) => (
            <NavLink
              key={l.to}
              to={l.to}
              data-testid={l.testid}
              className={({ isActive }) =>
                `text-sm font-medium transition-colors duration-300 hover:text-[#B85C43] ${
                  isActive ? "text-[#B85C43]" : "text-[#3E4A43]"
                }`
              }
            >
              {l.label}
            </NavLink>
          ))}
          <Link to="/booking" data-testid="header-book-cta" className="btn-primary !px-6 !py-2.5">
            Book an appointment
          </Link>
        </nav>

        <button
          data-testid="mobile-menu-toggle"
          className="rounded-full border border-[#E2DACD] p-2.5 text-[#2A3630] lg:hidden"
          onClick={() => setOpen((v) => !v)}
          aria-label={open ? "Close menu" : "Open menu"}
          aria-expanded={open}
        >
          {open ? <X size={20} /> : <Menu size={20} />}
        </button>
      </div>

      <AnimatePresence>
        {open && (
          <motion.nav
            key={location.pathname}
            initial={{ height: 0, opacity: 0 }}
            animate={{ height: "auto", opacity: 1 }}
            exit={{ height: 0, opacity: 0 }}
            transition={{ duration: 0.35, ease: [0.22, 1, 0.36, 1] }}
            className="overflow-hidden border-t border-[#E2DACD]/60 bg-[#FAF7F2]/95 backdrop-blur-md lg:hidden"
            aria-label="Mobile navigation"
          >
            <div className="flex flex-col gap-1 px-5 py-4">
              {NAV_LINKS.map((l) => (
                <NavLink
                  key={l.to}
                  to={l.to}
                  data-testid={`mobile-${l.testid}`}
                  onClick={() => setOpen(false)}
                  className={({ isActive }) =>
                    `rounded-xl px-4 py-3 text-base font-medium ${isActive ? "bg-[#E3ECE7] text-[#1E2723]" : "text-[#3E4A43]"}`
                  }
                >
                  {l.label}
                </NavLink>
              ))}
              <Link to="/booking" data-testid="mobile-header-book-cta" onClick={() => setOpen(false)} className="btn-primary mt-2">
                Book an appointment
              </Link>
            </div>
          </motion.nav>
        )}
      </AnimatePresence>
    </header>
  );
};
